import React from 'react';
import {useWatch} from "react-hook-form";
import {financial} from "v4/utils";

export default function LineTotal({names}) {
    const [unitPriceExclVat, quantity, discountValue, discountType] = useWatch({
        name: [
            names.unitPriceExclVat,
            names.quantity,
            names.discountValue,
            names.discountType,
        ],
    });

    return getTotal([unitPriceExclVat, quantity, discountValue, discountType]);
}

function getTotal([unit_price = 0, quantity = 0, discount = 0, discount_type = 'amount']) {
    const discountByUnitIfPercentage = discount_type === 'percentage' ? parseFloat((unit_price * (discount / 100)).toFixed(2)) : 0;
    return <>
        {
            discount > 0 && (
                <p className="discount">
                    {
                        financial(unit_price * quantity)
                    }
                </p>
            )
        }
        {discount_type === 'amount' && <p>{financial((unit_price * quantity) - discount)}</p>}
        {
            discount_type === 'percentage' && (
                <p>
                    {
                        financial((unit_price - discountByUnitIfPercentage) * quantity)
                    }
                </p>
            )
        }
    </>
}
